import React, { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { changePassword } from 'lib/communication/userInfo';
import Spinner from 'components/Spinner/Spinner';
import { logout } from 'lib/communication';
import ButtonComponent from 'components/ButtonComponent';
import { useUser } from 'reducers';
import { MIN_PASSWORD_LENGTH } from 'services';

const ChangePassword = () => {
    const [waiting, setWaiting] = useState(false);
    const history = useHistory();
    const [isOldPasswordValid, setIsOldPasswordValid] = useState(true);
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [pwdMatch, setPwdMatch] = useState(true);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordRepeat, setNewPasswordRepeat] = useState('');
    const [showPasswordChangeSuccess, setShowPasswordChangeSuccess] = useState(false);

    const user = useUser();

    const handleNewPasswordChange = (e: any): void => {
        const updatedPwd = e.target.value;
        setIsPasswordValid(updatedPwd.length >= MIN_PASSWORD_LENGTH);
        setNewPassword(updatedPwd);
        setPwdMatch(updatedPwd === newPasswordRepeat);
    };

    const handleNewPasswordRepeatChange = (e: any): void => {
        const updatedPwdRepeat = e.target.value;
        setNewPasswordRepeat(updatedPwdRepeat);
        setPwdMatch(newPassword === updatedPwdRepeat);
    };

    const handleOldPasswordChange = (e: any): void => {
        setIsOldPasswordValid(true);
        const updatedOldPassword = e.target.value;
        setOldPassword(updatedOldPassword);
    };

    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setWaiting(true);

        try {
            if (newPassword.length < MIN_PASSWORD_LENGTH) {
                setIsPasswordValid(false);
                return;
            }
            const result = await changePassword(oldPassword, newPassword);
            if (result === null) {
                return;
            }
            if (result.includes('hasło lub')) {
                setIsOldPasswordValid(false);
            } else if (result === 'Hasło za krótkie') {
                setIsPasswordValid(false);
            } else {
                sessionStorage.setItem('logout', 'true');
                setShowPasswordChangeSuccess(true);
            }
        } catch (err) { } finally {
            setWaiting(false);
        }
    };

    const goBack = () => {
        logout();
        history.push(process.env.PUBLIC_URL);
    };
    if (user === null) history.push(process.env.PUBLIC_URL);
    return (
        <>
            <h2>Proszę utworzyć nowe hasło</h2>
            {waiting && <Spinner />}
            <div className='Login'>
                <Form noValidate onSubmit={onSubmit} className='Login-body'>
                    <Form.Control hidden id='login' value={user?.login} />
                    <Form.Group controlId='oldPassword'>
                        <Form.Label>Dotychczasowe hasło</Form.Label>
                        <Form.Control type='password' autoComplete='password' required onChange={(e) => handleOldPasswordChange(e)} />
                        {!isOldPasswordValid && <Form.Label style={{ color: '#dc3545', marginBottom: 0 }}>Podane hasło jest nieprawidłowe</Form.Label>}
                    </Form.Group>
                    <Form.Group controlId='newPassword'>
                        {}
                        <Form.Label>Nowe hasło</Form.Label>
                        <Form.Control
                            name='new-password-field'
                            type='password'
                            required
                            autoComplete='off'
                            isInvalid={!isPasswordValid && newPassword.length !== 0}
                            isValid={isPasswordValid}
                            onChange={(e) => handleNewPasswordChange(e)}
                        />
                        {!isPasswordValid && <Form.Label style={{ marginBottom: 0 }}>Hasło musi mieć minimum 8 znaków</Form.Label>}
                    </Form.Group>
                    <Form.Group controlId='newPasswordRepeat'>
                        <Form.Label>Powtórz nowe hasło</Form.Label>
                        <Form.Control
                            name='new-password-repeat'
                            type='password'
                            required
                            autoComplete='off'
                            aria-autocomplete='none'
                            isInvalid={!pwdMatch}
                            onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => e.preventDefault()}
                            isValid={isPasswordValid && pwdMatch && newPasswordRepeat.length !== 0}
                            onChange={(e) => handleNewPasswordRepeatChange(e)}
                        />
                        {!pwdMatch && <Form.Label style={{ color: '#dc3545', marginBottom: 0 }}>Hasła różnią się od siebie</Form.Label>}
                    </Form.Group>
                    {
                        user?.forcePwdChange && <ButtonComponent
                            text='Wróć do logowania'
                            onClick={goBack}
                            onHoverAnimation={3}
                        />
                    }
                    <ButtonComponent
                        text='Zmień hasło'
                        type='submit'
                        disabled={!pwdMatch || !isPasswordValid}
                        onHoverAnimation={3}
                    />
                </Form>
            </div>
            <Modal show={showPasswordChangeSuccess} backdrop='static'>
                <Modal.Header className='Custom-modal-header'>
                    <Modal.Title>Zmieniono hasło</Modal.Title>
                </Modal.Header>
                <Modal.Body>Zmiana hasła powiodła się, za chwile zostaniesz wylogowany i przeniesiony do strony głównej. Zaloguj się ponownie nowym hasłem</Modal.Body>
                <Modal.Footer className='Custom-modal-footer'>
                    <ButtonComponent variant='primary' text='Kontynuuj' onHoverAnimation={3} margin='0' onClick={() => { setShowPasswordChangeSuccess(false); logout(); history.push(process.env.PUBLIC_URL); }} brandColoredButton={false} />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChangePassword;
